import actionTypes from '../../action-types'

export default (id, name) => ({
  type: actionTypes.CUSTOMER.SET_BASIC_INFO,
  payload: {
    id,
    name,
  },
})
